module.exports = __webpack_public_path__ + "img/vertical_6_5_5012.b0e385af.png";